import classNames from 'classnames'
import { Button } from '#app/components/ui/button.tsx'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

export type NotificationProps = {
	issue: string | null
	onClickSuccess?: () => void
	onClickDecline?: () => void
}

const valid_issues = ['unauthorized', 'account-deleted', 'sin_required', 'ssn_required', 'T1013_required', 'latest-return-created']

/**
 * Suggested colors for different issues
 *
 * error: bg-red-600
 * warning: bg-amber-600
 * success: bg-green-600
 *
 * @param issue
 * @param onClickSuccess
 * @param onClickDecline
 * @constructor
 */
const Notification = ({ issue = null, onClickSuccess, onClickDecline }: NotificationProps) => {
	const { t } = useTranslation()
	const [show, setShow] = useState(issue)

	const currentYear = new Date().getFullYear() + ''
	const latestTaxYear = new Date().getFullYear() - 1 + ''

	if (!valid_issues.includes(issue || '')) {
		return null
	}

	let color = ''
	let textColor = 'text-white'
	let title = ''
	let description = ''

	switch (issue) {
		case 'unauthorized':
			color = 'bg-amber-400'
			textColor = 'text-yellow-900'
			title = t('notifications.unauthorized.title')
			description = t('notifications.unauthorized.description')
			break
		case 'account-deleted':
			color = 'bg-amber-400'
			textColor = 'text-yellow-900'
			title = t('notifications.accountDeleted.title')
			description = t('notifications.accountDeleted.description')
			break
		case 'sin_required':
			color = 'bg-amber-600'
			title = t('notifications.sinRequired.title')
			description = t('notifications.sinRequired.description')
			break
		case 'ssn_required':
			color = 'bg-amber-600'
			title = t('notifications.ssnRequired.title')
			description = t('notifications.ssnRequired.description')
			break
		case 'T1013_required':
			color = 'bg-amber-600'
			title = t('notifications.t1013Required.title')
			description = t('notifications.t1013Required.description')
			break
		case 'latest-return-created':
			color = 'bg-yellow-400'
			textColor = 'text-black'
			title = t('notifications.latestReturnCreated.title', { year: latestTaxYear })
			description = t('notifications.latestReturnCreated.description', { year: currentYear })
			break
	}

	function handleClickSuccess() {
		setShow(null)
		// @ts-ignore
		onClickSuccess()
	}

	function handleClickDecline() {
		setShow(null)
		// @ts-ignore
		onClickDecline()
	}

	return (
		<div>
			{show !== null && (
				<div className={classNames(color, textColor, 'my-4 flex items-center rounded-lg p-4')}>
					<div className="flex w-full items-center justify-between font-bold">
						<div className="mr-3">
							<div className="mb-2 flex">{title}</div>
							<div className="flex text-sm" dangerouslySetInnerHTML={{ __html: description as string }}></div>

							{'sin_required' === issue && (
								<div className="mt-4 flex gap-3">
									<div>
										<Button size="sm" className="bg-neutral-900 dark:bg-blue-600 dark:hover:bg-blue-700 px-2 font-bold text-white" onClick={handleClickSuccess}>
											{t('notifications.submit')}
										</Button>
									</div>
									<div>
										<Button size="sm" className="bg-neutral-900 dark:bg-blue-600 dark:hover:bg-blue-700 px-2 font-bold text-white" onClick={handleClickDecline}>
											{t('notifications.decline')}
										</Button>
									</div>
								</div>
							)}
							{'ssn_required' === issue && (
								<div className="mt-4 flex gap-3">
									<div>
										<Button size="sm" className="bg-neutral-900 dark:bg-blue-600 dark:hover:bg-blue-700 px-2 font-bold text-white" onClick={handleClickSuccess}>
											{t('notifications.submit')}
										</Button>
									</div>
									<div>
										<Button size="sm" className="bg-neutral-900 dark:bg-blue-600 dark:hover:bg-blue-700 px-2 font-bold text-white" onClick={handleClickDecline}>
											{t('notifications.decline')}
										</Button>
									</div>
								</div>
							)}
							{'T1013_required' === issue && (
								<div className="mt-4 flex gap-3">
									<div>
										<Button size="sm" className="bg-neutral-900 dark:bg-blue-600 dark:hover:bg-blue-700 px-2 font-bold text-white" onClick={handleClickSuccess}>
											{t('notifications.sign')}
										</Button>
									</div>
									<div>
										<Button size="sm" className="bg-neutral-900 dark:bg-blue-600 dark:hover:bg-blue-700 px-2 font-bold text-white" onClick={handleClickDecline}>
											{t('notifications.decline')}
										</Button>
									</div>
								</div>
							)}
						</div>
						<div>
							<Button size="sm" className="bg-neutral-900 dark:bg-blue-600 dark:hover:bg-blue-700 px-2 font-bold text-white" onClick={handleClickSuccess}>
								{t('notifications.close')}
							</Button>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}

export default Notification
